module.exports = __webpack_public_path__ + "static/img/300_TO8_1961.a74702f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/300_TO8_1961.jpg
// module id = po22
// module chunks = 0